import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import Home from './pages/Home';
import UCaaS from './pages/UCaaS';
import SolutionPage from './pages/SolutionPage';
import Compare from './pages/Compare';
import ProviderMatrix from './pages/ProviderMatrix';
import RealityCheck from './pages/RealityCheck';
import About from './pages/About';
import Resources from './pages/Resources';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Header />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ucaas" element={<UCaaS />} />
          <Route path="/ccaas" element={<SolutionPage type="ccaas" />} />
          <Route path="/wireless" element={<SolutionPage type="wireless" />} />
          <Route path="/compare-providers" element={<Compare />} />
          <Route path="/provider-matrix" element={<ProviderMatrix />} />
          <Route path="/tech-reality-check" element={<RealityCheck />} />
          <Route path="/about" element={<About />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      {/* Persistent site-wide placeholder. Insert Orimon.ai embed code inside ChatWidget.jsx. */}
      <ChatWidget />
      <a className="mobile-call" href="tel:+17185550142">Call an advisor</a>
    </BrowserRouter>
  );
}

export default App;